import React from 'react';

import { Redux, Slices } from 'spwa-ui-library';
import css from './index.module.scss';

const { useSelector } = Redux;
const { selectProductById } = Slices.productSlice;

function CartItemInfo({ value, index }) {
  const productInfo = useSelector((state) => selectProductById(state, value.id));
  const defaultName = value?.name || productInfo?.name || productInfo?.title || '';

  return (
    <div className={css.nameWrapper} key={index}>
      <span className={css.qty}>{value.qty ? value.qty : '1'}</span>
      <span>{value?.additionalInfo?.name || defaultName}</span>
      {value?.additionalInfo?.name?.length > index + 1 ? '' : ', '}
    </div>
  );
}

export default CartItemInfo;
